import { fetchCart } from "theme";

class CartOperationsQueue {
  constructor() {
    this.queue = [];
    this.isRunning = false;
    this.latestResult = null;
    this.runPromise = null;
  }

  async runOperation(op) {
    if (op) {
      this.queue.push(op);
    }
    if (this.isRunning) {
      // console.log("Queue is already running...");
      return this.runPromise;
    }
    this.isRunning = true;
    this.runPromise = (async () => {
      while (this.queue.length > 0) {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          }),
        );
        const operation = this.queue.shift();

        const dataString = JSON.stringify(
          operation.httpBody
            ? {
                ...operation.httpBody,
                sections: sectionsToBundle.join(","),
              }
            : { sections: sectionsToBundle.join(",") },
        );

        this.latestResult = await fetch(`/cart/${operation.type}.js`, {
          method: operation.httpMethod,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: dataString,
        })
          .then((res) => {
            if (res.ok) {
              return res.json();
            }
            console.error(
              "Cart operation failed:",
              operation.type,
              operation.httpMethod,
            );
            return null;
          })
          .catch((err) => {
            console.error("Cart operation:", err);
            return null;
          });
      }
      this.isRunning = false;
      console.log("Cart operation completed!");
      this.latestResult.items = this.latestResult.items.filter(item=>item.quantity>0)
      return this.latestResult;
    })();

    return this.runPromise;
  }
}

document.addEventListener("DOMContentLoaded", async (event) => {
  const GWS_SKUS = ["2602587"];
  function applyGwsAttributes(cart, cartOps) {
    const items = cart.items;
    const linesByVarId = items.reduce((accumulator, current, currentIndex) => {
      var _a, _b;
      const varId = `${current.variant_id}`;
      const lines = accumulator.get(varId);
      const gwsQty = parseInt(
        ((_b =
          (_a = current.properties["Gift wrap quantity"]) === null ||
          _a === void 0
            ? void 0
            : _a.match(/\((\d+)\)/)) === null || _b === void 0
          ? void 0
          : _b[1]) || "0",
      );
      // console.log("gwsQty", gwsQty);
      if (lines) {
        lines.totalQuantity += current.quantity;
        lines.gwsTotalQty = gwsQty;
        lines.lines.push({
          line: currentIndex + 1,
          key: current.key,
          id: current.id,
          varId: varId,
          sku: current.sku,
          quantity: current.quantity,
          giftWrapQty: gwsQty,
          properties: current.properties,
        });
      } else {
        accumulator.set(varId, {
          totalQuantity: current.quantity,
          gwsTotalQty: gwsQty,
          lines: [
            {
              line: currentIndex + 1,
              key: current.key,
              id: current.id,
              varId: varId,
              sku: current.sku,
              quantity: current.quantity,
              giftWrapQty: gwsQty,
              properties: current.properties,
            },
          ],
        });
      }
      // console.log("accumulator.get(varId):",accumulator.get(varId))
      return accumulator;
    }, new Map());
    const toRemoveGWS = [];
    const toUpdateGifts = [];
    const toUpdateGiftWraps = [];
    const giftWrapMap = new Map();
    const giftWraps = [];

    for (const item of items) {
      const giftId = item.properties["_gift_id"];
      if (giftId) {
        const giftWrap = giftWrapMap.get(giftId);
        if (giftWrap) {
          giftWrap.quantity += item.quantity;
        } else {
          giftWrapMap.set(giftId, {
            key: item.key,
            quantity: item.quantity,
            properties: item.properties,
          });
        }
      }
      if (GWS_SKUS.includes(item.sku || "")) {
        giftWraps.push({
          key: item.key,
          quantity: item.quantity,
          giftId,
          properties: item.properties,
        });
      }
    }
    for (const gws of giftWraps) {
      if (gws.giftId) {
        const linesGroup = linesByVarId.get(gws.giftId);
        if (linesGroup) {
          if (
            gws.quantity === linesGroup.gwsTotalQty &&
            gws.quantity <= linesGroup.totalQuantity
          ) {
            continue;
          }
          let gwsQty =
            gws.quantity < linesGroup.totalQuantity
              ? gws.quantity
              : linesGroup.totalQuantity;
          // console.log("gwsQty",gwsQty)
          for (const line of linesGroup.lines) {
            toUpdateGifts.push({
              line: line.line,
              quantity: line.quantity,
              properties: {
                ...line.properties,
                _gift_wrap_id: line.varId,
                "Packaging choice": "Gift wrap +₱50",
                "Remove price tag": "Yes",
                Gift: "Yes",
                "Gift wrap quantity": `Wrap (${gwsQty}) ${gwsQty > 1 ? "items" : "item"}`,
              },
            });
          }
          // console.log("gwsQty",gwsQty,gws.quantity)
          if (gws.quantity != gwsQty) {
            toUpdateGiftWraps.push({
              id: gws.key,
              quantity: gwsQty,
            });
          }
        } else {
          toRemoveGWS.push(gws.key);
        }
      } else {
        toRemoveGWS.push(gws.key);
      }
    }
    let lineNumber = 0;
    for (const item of items) {
      lineNumber += 1;
      if (!GWS_SKUS.includes(item.sku || "")) {
        const varId = `${item.id}`;
        const giftAttr = [];
        if (item.properties["_gift_wrap_id"]) {
          giftAttr.push(item.properties["_gift_wrap_id"]);
        }
        if (item.properties["Gift wrap quantity"]) {
          giftAttr.push(item.properties["Gift wrap quantity"]);
        }
        if (item.properties["Gift"]) {
          giftAttr.push(item.properties["Gift"]);
        }
        if (item.properties["Gift wrap quantity"]) {
          giftAttr.push(item.properties["Gift wrap quantity"]);
        }
        const giftWrap = giftWrapMap.get(varId);
        if (!giftWrap && giftAttr.length) {
          toUpdateGifts.push({
            line: lineNumber,
            quantity: item.quantity,
            properties: {
              _:"",
              // _gift_wrap_id: "",
              // "Packaging choice": "",
              // "Remove price tag": "",
              // "Gift wrap quantity": "",
              // Gift: "",
            },
          });
        }
      }
    }
    // console.log("linesByVarId", linesByVarId);
    // console.log("giftWraps", giftWraps);
    // console.log("giftWrapMap", giftWrapMap);
    // console.log("toRemoveGWS", toRemoveGWS);
    // console.log("toUpdateGifts", toUpdateGifts);
    // console.log("toUpdateGiftWraps", toUpdateGiftWraps);
    if (toUpdateGifts.length) {
      for (const gift of toUpdateGifts) {
        cartOps.runOperation({
          type: "change",
          httpMethod: "POST",
          httpBody: gift,
        });
      }
    }
    if (toUpdateGiftWraps.length) {
      for (const gws of toUpdateGiftWraps) {
        cartOps.runOperation({
          type: "change",
          httpMethod: "POST",
          httpBody: gws,
        });
      }
    }
    // clear
    if (toRemoveGWS.length) {
      cartOps.runOperation({
        type: "update",
        httpMethod: "POST",
        httpBody: {
          updates: Object.fromEntries(
            toRemoveGWS.map((gws) => {
              return [gws, 0];
            }),
          ),
        },
      });
    }
    if (
      toRemoveGWS.length ||
      toUpdateGiftWraps.length ||
      toUpdateGifts.length
    ) {
      return true;
    }
    return false;
  }
  function getDiscounts(cart) {
    return fetch("/a/eacs/sh-app/promos/discounts", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cart),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        console.error("get discounts failed, status:", res.status);
        return null;
      })
      .catch((err) => {
        console.error("get discounts failed:", err);
        return null;
      });
  }
  async function applyDiscounts(cart) {
    const discountedCart = await getDiscounts(cart);
    if (!discountedCart) {
      return [false, null];
    }
    if (
      cart.attributes._dis === discountedCart._dis &&
      cart.attributes._dsig === discountedCart._dsig
    ) {
      return [false, null];
    }

    return [true, discountedCart];
  }
  function getGwps(cart) {
    return fetch("/a/eacs/sh-app/promos/gwp", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cart),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        console.error("getGWPS failed, status:", res.status);
        return null;
      })
      .catch((err) => {
        console.error("getGWPS failed:", err);
        return null;
      });
  }
  async function sha256Hex(obj) {
    const message = JSON.stringify(obj);
    const messageBytes = new TextEncoder().encode(message);
    return crypto.subtle.digest("SHA-256", messageBytes).then((hashBytes) => {
      const hashHex = Array.from(new Uint8Array(hashBytes)).reduce((acc, b) => {
        return acc + b.toString(16).padStart(2, "0");
      }, "");
      // .map((b) => b.toString(16).padStart(2, "0"))
      // .join("");
      return hashHex;
    });
  }
  async function addGwpsToCart(cart, cartOps) {

    const res = await getGwps(cart);
    if (!res || !res.gwps?.length || !cart?.items?.length) {
      if (res && cart.attributes._gwp !== res._gwp) {
        return [true, { _gwp: res._gwp }];
      }
      return [false, null];
    }
    const gwps = res.gwps;
    const currentCartGwps = [];
    const newCartGwps = [];

    for (const cartItem of cart.items) {
      if (
        cartItem.properties?._isGwp === "true" ||
        cartItem.product_type?.toLowerCase() === "gwp"
      ) {
        currentCartGwps.push({
          id: cartItem.id,
          quantity: cartItem.quantity,
        });
      }
    }
    for (const gwp of gwps) {
      newCartGwps.push({
        id: gwp.id,
        quantity: gwp.quantity,
      });
    }
    currentCartGwps.sort((a, b) => a.id - b.id);
    newCartGwps.sort((a, b) => a.id - b.id);
    const [hashOld, hashNew] = await Promise.all([
      sha256Hex(currentCartGwps || []),
      sha256Hex(newCartGwps || []),
    ]);

       
    if (hashOld === hashNew) {
      if (cart.attributes._gwp !== res._gwp) {
        return [true, { _gwp: res._gwp }];
      }
      // console.log("cache");
      return [false, null];
    }

    // clear
    cartOps.runOperation({
      type: "update",
      httpMethod: "POST",
      httpBody: {
        updates: Object.fromEntries(
          gwps.map((gwp) => {
            return [gwp.id, 0];
          }),
        ),
      },
    });
    // add gwp
    const gwpsToAdd = gwps.filter((gwp) => gwp.quantity > 0);
    if (gwpsToAdd.length > 0) {
      cartOps.runOperation({
        type: "add",
        httpMethod: "POST",
        httpBody: { items: gwpsToAdd },
      });
    }

    return [true, { _gwp: res._gwp }];
  }
  async function applyFreeChoco(cart) {
    const res = await fetch("/a/eacs/sh-app/promos/free-choco", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        console.error("applyFreeChoco failed, status:", res.status);
        return null;
        // throw "applyFreeChoco error";
      })
      .catch((err) => {
        console.error("applyFreeChoco failed:", err);
        return null;
      });

    if (!res) {
      return [false, null];
    }

    let freeChoco = "";
    if (res?.freeChoco) {
      freeChoco = "Yes";
    }

    if (cart.attributes._free_chocolate === freeChoco) {
      return [false, null];
    } else if (!cart.attributes._free_chocolate && !freeChoco) {
      return [false, null];
    }

    return [true, { _free_chocolate: freeChoco }];
  }
  async function getSegmentsAttribute(cart) {
    const segments = await fetch(`/a/eacs/sh-app/promos/segments`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(function (res) {
        if (res.ok) {
          return res.json();
        }
        console.error("getSegmentsAttribute failed, status:", res.status);
        return null;
      })
      .catch((err) => {
        console.error("getSegmentsAttribute failed:", err);
        return null;
      });

    if (!segments) {
      return [false, null];
    }

    if (
      (cart.attributes._signature === segments._signature &&
        cart.attributes._segments === segments._segments) ||
      (!cart.attributes._signature &&
        !segments._signature &&
        !cart.attributes._segments &&
        !segments._segments)
    ) {
      // console.log("cache");
      return [false, null];
    }
    return [true, segments];
  }
  async function runCartOperations(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );
    let latestCart = cart;
    if (!latestCart.item_count) {
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true }),
      );
      return;
    }
    const cartOps = new CartOperationsQueue();

    const changedAttributes = await Promise.all([
      applyDiscounts(latestCart),
      applyFreeChoco(latestCart),
      getSegmentsAttribute(latestCart),
      addGwpsToCart(latestCart, cartOps),
    ]);

    let newCartAttributes = {};
    let cartChanged = false;
    for (const [changed, attributes] of changedAttributes) {
      // console.log("changed, attributes", changed, attributes);
      if (changed) {
        cartChanged = changed;
        newCartAttributes = { ...newCartAttributes, ...attributes };
      }
    }
    // console.log("newCartAttributes", newCartAttributes);
    if (!cartChanged) {
      if (applyGwsAttributes(latestCart, cartOps)) {
        const newCart = await cartOps.runOperation();
        if (
          window.location.pathname.startsWith("/cart") ||
          window.location.pathname.includes("/checkouts/")
        ) {
          window.location.reload();
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "promo:update",
                cart: newCart,
              },
            }),
          );
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true }),
          );
        }
      }

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true }),
      );
      return;
    }
    cartOps.runOperation({
      type: "update",
      httpMethod: "POST",
      httpBody: {
        attributes: newCartAttributes,
      },
    });
    let newCart = await cartOps.runOperation();
    // console.log("new cart after promos", newCart);
    if (applyGwsAttributes(newCart, cartOps)) {
      newCart = await cartOps.runOperation();
    }

    if (
      window.location.pathname.startsWith("/cart") ||
      window.location.pathname.includes("/checkouts/")
    ) {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "promo:update",
            cart: newCart,
          },
        }),
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true }),
      );
    }
  }

  ////////////////////////////////////
  const cart = await fetchCart;

  runCartOperations(cart);
  document.addEventListener("cart:change", (event) => {

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );
    const cart = event.detail["cart"];
    runCartOperations(cart);
  });
});
